import { imgSrc, imgAlt } from "@/data/site";

export function Img({ k, alt, className = "", sizes = "100vw", priority = false, width = 1200, height = 800 }) {
  return (
    <img
      src={imgSrc(k, 1200)}
      srcSet={[480, 800, 1200, 1800].map((w) => `${imgSrc(k, w)} ${w}w`).join(", ")}
      sizes={sizes}
      alt={alt ?? imgAlt(k)}
      width={width}
      height={height}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      fetchpriority={priority ? "high" : "auto"}
      className={className}
    />
  );
}
